//
// PortableBidi.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../moduleBuilder";
import ClosetObject from "../../ClosetObject";
import "../../lib";
import "./TextDirection";
import "./CharDirection";

var PortableBidi = createModule("commons::PortableBidi", [], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        getBidiName: [7],
        getRunLevel: [4,4],
        getDirection: [4],
        getRunEnd: [4,4],
        getCountParagraphs: [4],
        getLogicalRunLimit: [4,4],
        getProcessedLength: [4],
        getRunCount: [4],
        getRunBegin: [4,4],
        isMixed: [2],
        isRightToLeft: [2],
        setPara: [0,7,4],
        getLogicalRunLevel: [4,4],
        isLeftToRight: [2],
        getDirectionClass: [4,4],
        getLevelAt: [4,4],
        getLength: [4],
    },
    ,
    ,
]);
export default PortableBidi;
